<template>
  <!-- Begin Page Content -->
  <div>
    <section>
      <v-img
        src="/assets/img/cover.jpg"
        height="620"
        style="position: relative"
      >
        <v-container
          class="white--text text-center"
          style="
            margin: 0;
            position: absolute;
            top: 35%;
            left: 50%;
            transform: translate(-50%, -50%);
          "
        >
          <h1 style="font-weight: 500; font-size: 54pt">Машин сонгох</h1>
          <h4 style="font-size: 18pt">
            Сэлбэг хайх, тоноглол хайх, багаж хайх
          </h4>
          <v-row class="mx-auto mt-8">
            <v-col lg="3" md="auto" cols="12">
              <v-select
                :items="items"
                label="Үйлдвэрлэгч"
                outlined
                background-color="white"
              ></v-select>
            </v-col>
            <v-col lg="3" md="auto" cols="12">
              <v-select
                :items="items"
                label="Загвар"
                outlined
                background-color="white"
              ></v-select>
            </v-col>
            <v-col lg="3" md="auto" cols="12">
              <v-select
                :items="items"
                label="Модел"
                outlined
                background-color="white"
              ></v-select>
            </v-col>
            <v-col lg="3" md="auto" cols="12" class="d-flex flex-row">
              <v-select
                :items="items"
                label="Oн"
                outlined
                background-color="white"
              ></v-select>
              <v-btn x-large height="56" color="#A8101F" dark class="ml-3"
                >Хайх</v-btn
              >
            </v-col>
            <!-- <v-col class="d-flex align-start" lg="auto" md="auto" cols="12">
                
              </v-col> -->
          </v-row>
        </v-container>
        <v-container
          class="white--text text-center pb-0"
          style="
            margin: 0;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, -50%);
          "
        >
          <span
            style="
              border-right: 1px solid white;
              font-size: 18px;
              line-height: 21px;
            "
            class="pr-5"
            >Нийт сэлбэг: 321,000</span
          >
          <span class="pl-5" style="font-size: 18px; line-height: 21px"
            >Нийт загвар: 1298</span
          >
        </v-container>
      </v-img>
    </section>
    <section class="mt-8">
      <v-container v-if="selbegtypes != null">
        <v-row justify="space-around">
          <v-col
            v-for="(category, index) in selbegtypes"
            :key="index"
            cols="4"
            lg="1"
            md="1"
            sm="2"
            class="px-0"
          >
            <v-img
              style="cursor: pointer"
              width="70"
              class="mx-auto"
              :src="_getImage(category)"
              @click="
                $router.push({
                  name: 'CategoryItems',
                  params: { categoryId: category.id },
                })
              "
            />
            <p class="text-center mt-2">{{ category.name }}</p>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="mt-8">
      <v-container>
        <v-row>
          <v-col cols="12" lg="6" md="6" sm="12">
            <v-card>
              <v-img
                src="/assets/img/car1.png"
                height="30vh"
                class="pa-5 align-end"
                dark
              >
                <h1 class="text-h4" style="font-weight: bold">Spyder</h1>
                <span class="text-subtitle-2" style="font-weight: 300"
                  >Conquer the night with Spyder lighting products. The
                  illumination you demand. The look you aspire.</span
                >
              </v-img>
            </v-card>
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="12">
            <v-card>
              <v-img
                src="/assets/img/car2.png"
                height="30vh"
                class="pa-5 align-end"
                dark
              >
                <h1 class="text-h4" style="font-weight: bold">Torxe</h1>
                <span class="text-subtitle-2" style="font-weight: 300"
                  >Torxe never compromises with details, and all its products
                  are designed smartly - just like your vehicle. They last long
                  and ride hard.</span
                >
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- <section class="mt-16">
        <v-container>
          <v-card>
            <v-row>
              <v-col cols="4">
                <v-row class="pb-6">
                  <v-img src="/assets/img/grid1.jpg"></v-img>
                </v-row>
                <v-row>
                  <v-img src="/assets/img/grid2.jpg"></v-img>
                </v-row>
              </v-col>
              <v-col cols="4" class="py-0">
                <v-img
                  src="/assets/img/grid3.jpg"
                  style="height: 100%"
                ></v-img>
              </v-col>
              <v-col cols="4" class="border-green">
                <v-row class="pb-6">
                  <v-img src="/assets/img/grid4.jpg"></v-img>
                </v-row>
                <v-row>
                  <v-img src="/assets/img/grid5.jpg"></v-img>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </section> -->
    <section class="mt-8 pb-8">
      <v-container>
        <h4 class="mb-8 font-weight-bold">Xувийн дэлгүүр</h4>
        <v-row no-gutters>
          <text-card
            v-for="store in pinnedStores"
            :key="store.id"
            :datax="store"
          ></text-card>
        </v-row>
        <v-row justify="center">
          <v-btn class="text-button my-10" x-large outlined
            >Цааш үзэx
            <v-icon right size="24">mdi-chevron-down</v-icon>
          </v-btn>
        </v-row>
      </v-container>
    </section>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../firebaseConfig.js");
import BannerCard from "./BannerCard";
import TextCard from "./TextCard.vue";
export default {
  name: "Dashboard",
  data() {
    return {
      selbegtypes: null,
      cartypes: null,
      tab: null,
      pinnedStores: null,
    };
  },
  components: {
    TextCard,
    BannerCard,
  },
  created() {
    fb.db
      .collection("selbegtypes")
      .orderBy("createdAt", "asc")
      .get()
      .then((docs) => {
        this.selbegtypes = [];
        docs.forEach((doc) => {
          let selbegtype = doc.data();
          selbegtype.id = doc.id;
          selbegtype.ref = doc.ref;
          console.log(selbegtype);
          this.selbegtypes.push(selbegtype);
        });
      });
    fb.db
      .collection("cartypes")
      .orderBy("createdAt", "asc")
      .get()
      .then((docs) => {
        this.cartypes = [];
        docs.forEach((doc) => {
          let cartype = doc.data();
          cartype.id = doc.id;
          cartype.ref = doc.ref;
          this.cartypes.push(cartype);
        });
      });
    fb.db
      .collection("stores")
      .where("pin", "==", true)
      .orderBy("lastShowDate")
      .limit(6)
      .get()
      .then((querySnapshot) => {
        this.pinnedStores = [];
        querySnapshot.forEach(async (doc) => {
          let store = doc.data();
          store.ref = doc.ref;
          store.id = doc.id;
          this.pinnedStores.push(store);
        });
      });
  },
  methods: {
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {
        return obj.images[0]["fileUrl"];
      }
      return null;
    },
  },
  firestore: {
    selbegtypes: fb.db.collection("selbegtypes").orderBy("createdAt", "asc"),
  },
};
</script>

